import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KeyRound, ExternalLink, Check, AlertTriangle } from "lucide-react";

const PROVIDERS = [
  {
    key: "anthropic_configured",
    env: "ANTHROPIC_API_KEY",
    title: "Claude API (Anthropic)",
    tag: "// ATENA · /atena smart",
    href: "https://console.anthropic.com",
    hrefLabel: "console.anthropic.com",
  },
  {
    key: "openai_configured",
    env: "OPENAI_API_KEY",
    title: "OpenAI / GPT",
    tag: "// ATENA · /atena gpt",
    href: "https://platform.openai.com",
    hrefLabel: "platform.openai.com",
  },
];

export default function AiProviderKeys({ workspaceId }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!workspaceId) return;
    api.get("/settings/ai-keys", { params: { workspace_id: workspaceId } })
      .then((r) => setStatus(r.data))
      .catch(() => setStatus(null));
  }, [workspaceId]);

  if (!status) return null;

  return (
    <>
      {PROVIDERS.map((p) => {
        const ok = Boolean(status[p.key]);
        return (
          <section key={p.env} className="bg-surface border border-line/10 mt-6" data-testid={`ai-provider-${p.env}`}>
            <div className="px-5 py-4 border-b border-line/10 flex items-center gap-2">
              <KeyRound className={`w-4 h-4 ${ok ? "text-brand" : "text-fg-muted"}`} />
              <h3 className="font-bold tracking-tight">{p.title}</h3>
              <span className="label-tiny ml-2">{p.tag}</span>
              <span
                data-testid={`ai-provider-status-${p.env}`}
                className={`ml-auto flex items-center gap-1.5 text-xs ${ok ? "text-brand" : "text-fg-muted"}`}
              >
                {ok ? <Check className="w-3.5 h-3.5" /> : <AlertTriangle className="w-3.5 h-3.5" />}
                {ok ? "Configurat" : "Lipsă"}
              </span>
            </div>
            <div className="p-5 space-y-3">
              <div>
                <label htmlFor={`key-${p.env}`} className="label-tiny block mb-2">{p.env}</label>
                <input
                  id={`key-${p.env}`}
                  data-testid={`ai-key-${p.env}`}
                  type="password"
                  readOnly
                  value={ok ? "storedstoredstored" : ""}
                  placeholder="nu este setată"
                  aria-describedby={`key-help-${p.env}`}
                  className="input-flat mono w-full opacity-60 cursor-not-allowed"
                />
              </div>
              <p id={`key-help-${p.env}`} className="text-[11px] text-fg-muted leading-relaxed">
                Cheia se citește din environment-ul serverului și nu poate fi schimbată de aici —
                backend-ul rulează în container și nu are acces de scriere la fișierul cu secrete,
                iar o cheie salvată în baza de date ar ajunge în fiecare backup. Se adaugă pe server
                în <code className="mono text-fg/70">/home/qedara/apps/qedara-chat/.env</code>, apoi
                un deploy o preia. Valoarea nu e afișată niciodată înapoi.
              </p>
              <a
                href={p.href} target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-xs text-brand-2 hover:text-brand"
              >
                {p.hrefLabel} <ExternalLink className="w-3 h-3" />
              </a>
            </div>
          </section>
        );
      })}
    </>
  );
}
